export const getTotalAttachmentsSize = (attachments)=>attachments.reduce((sum, file)=>sum + file.fileSize, 0);
export const isAttachButtonDisabled = (param)=>{
    let { attachments, isUploading, maxTotalSize } = param;
    return isUploading || getTotalAttachmentsSize(attachments) >= maxTotalSize;
};
